import React from 'react';

const LoadingSpinner = ({ hidden }) => {
  return hidden
    ? null
    : <img src="/assets/load-black.gif" />;
};

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./client/Core/Components/LoadingSpinner/LoadingSpinner.jsx